import { removeTrailingSlash } from "../helpers";
import trackingSocket from "./trackingSocket";

function snapped(value, gridSize) {
  return Math.floor(value / gridSize) * gridSize;
}

export function createSocketTransport() {
  trackingSocket.init();
  return (eventName, payload) => trackingSocket.track(eventName, payload);
}

function getTiming() {
  const navigation = performance.getEntriesByType("navigation");
  if (navigation && navigation.length > 0) {
    const timings = navigation[0];
    return {
      domInteractive: timings.domInteractive,
      domComplete: timings.domComplete,
      loaded: timings.loadEventEnd,
    };
  }
  return undefined;
}

export class Tracking {
  constructor(transport = createSocketTransport()) {
    this.version = "v1";

    this.transport = transport;
  }

  setTransport(transport) {
    this.transport = transport;
  }

  init() {
    return this.track("tracking.init", {
      userAgent: navigator.userAgent,
      language: navigator.language,
      referrer: document.referrer || "",
      screen: {
        height: snapped(window.screen.height, 10),
        width: snapped(window.screen.width, 10),
      },
      path: removeTrailingSlash(window.location.pathname),
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      timing: getTiming(),
    });
  }

  track(eventName, params = {}) {
    // Skip if user does not want to be tracked
    if (navigator.doNotTrack === "1") {
      return;
    }
    return this.transport(eventName, params);
  }
}

const instance = new Tracking();

export default instance;
